import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ExternalLink } from "lucide-react";

const AI_ENGINES = [
  { name: "AI Overviews", desc: "Google — intégré directement dans la SERP. Impact majeur sur YMYL.", color: "#FF453A" },
  { name: "ChatGPT Search", desc: "OpenAI — index élargi, sources premium privilégiées.", color: "#10A37F" },
  { name: "Perplexity", desc: "Focus sur la citation de sources. Format 'Pages' émergent.", color: "#20B2AA" },
  { name: "Gemini", desc: "Google — moteur conversationnel intégré à Search.", color: "#4285F4" },
  { name: "Claude", desc: "Anthropic — analyse et synthèse, moins orienté web search.", color: "#D97706" },
];

export default function AIWatchPage() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    (async () => {
      const { data } = await api.get("/feed?limit=40");
      const aiItems = (data.items || []).filter(it => {
        const t = (it.title || "") + " " + (it.summary || "");
        return /AI Overview|ChatGPT|Perplexity|Gemini|SGE|LLM|IA/i.test(t);
      });
      setItems(aiItems);
    })();
  }, []);

  return (
    <div className="p-6 lg:p-10 max-w-6xl">
      <div className="text-[11px] font-mono uppercase tracking-[0.3em] text-[#FF453A] mb-3">
        Veille dédiée · AI Search
      </div>
      <h1 className="font-display text-4xl md:text-5xl font-black tracking-tight mb-4" data-testid="ai-watch-title">
        Le SEO à l'ère des LLM.
      </h1>
      <p className="text-white/50 mb-10 max-w-2xl">
        Ce que citent AI Overviews, ChatGPT, Perplexity, Gemini et Claude. Les formats qui gagnent. Les marques qui percent.
      </p>

      <div className="grid md:grid-cols-2 lg:grid-cols-5 border-t border-l border-white/10 mb-12">
        {AI_ENGINES.map((e) => (
          <div key={e.name} className="p-5 border-r border-b border-white/10 relative overflow-hidden" data-testid={`ai-engine-${e.name}`}>
            <div className="w-3 h-3 mb-4" style={{ background: e.color }} />
            <div className="font-display font-bold text-base mb-2">{e.name}</div>
            <div className="text-xs text-white/50 leading-relaxed">{e.desc}</div>
          </div>
        ))}
      </div>

      <div className="text-[11px] font-mono uppercase tracking-[0.3em] text-white/40 mb-4">
        Actualités & analyses
      </div>
      <div className="border-t border-l border-white/10">
        {items.length === 0 ? (
          <div className="p-6 border-r border-b border-white/10 text-white/40 text-sm">
            Pas d'actualités IA récentes détectées. Nouveau scan dans 2h.
          </div>
        ) : items.map((it, i) => (
          <a
            key={i}
            href={it.url}
            target="_blank"
            rel="noopener noreferrer"
            className="block p-5 border-r border-b border-white/10 hover:bg-white/[0.03] transition-colors group"
            data-testid={`ai-feed-row-${i}`}
          >
            <div className="flex items-center gap-4 mb-1 text-[10px] font-mono uppercase tracking-[0.2em]">
              <span className="text-[#FF453A]">{it.source}</span>
              <ExternalLink className="w-3 h-3 text-white/20 ml-auto group-hover:text-[#FF453A]" />
            </div>
            <h4 className="font-display text-lg font-semibold leading-snug group-hover:text-[#FFD60A] transition-colors line-clamp-2">
              {it.title}
            </h4>
            {it.summary && <p className="text-sm text-white/55 line-clamp-2 mt-1">{it.summary}</p>}
          </a>
        ))}
      </div>
    </div>
  );
}
